import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { consultantHealthInsurerSingleUpdate } from '../../lib/redux/actions/consultantHealthInsurer';
import PropTypes from 'prop-types';
import { Cell } from 'react-sticky-table';
import { isSeniorStaff } from '../../lib/helper/authorisation';

const mapDispatchToProps = {
  consultantHealthInsurerSingleUpdate,
};

class EditableConsultantHealthInsurerLabelCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      fieldValue: props.consultantHealthInsurer.overrideLabel,
    };
    this.handleChange = this.handleChange.bind(this);
    this.startEditing = this.startEditing.bind(this);
    this.stopEditing = this.stopEditing.bind(this);
    this.saveAndStopEditing = this.saveAndStopEditing.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.consultantHealthInsurer !== this.props.consultantHealthInsurer) {
      this.setState(() => ({
        fieldValue: this.props.consultantHealthInsurer.overrideLabel,
      }));
    }
  }

  handleChange(event) {
    this.setState(() => ({ fieldValue: event.target.value }));
  }

  startEditing() {
    if (!this.props.consultantHealthInsurer.healthInsurer.canHaveOverrideLabel || !isSeniorStaff()) {
      return false;
    }
    this.setState(() => ({ isEditing: true }));
  }

  stopEditing(e) {
    e.stopPropagation();
    this.setState(() => ({ isEditing: false, fieldValue: this.props.consultantHealthInsurer.overrideLabel }));
  }

  saveAndStopEditing(e) {
    if (!isSeniorStaff()) {
      return;
    }
    e.stopPropagation();
    const previousValue = this.props.consultantHealthInsurer.overrideLabel;
    this.props.consultantHealthInsurerSingleUpdate({ overrideLabel: this.state.fieldValue }, this.props.consultantHealthInsurer.id)
      .catch(() => {
        this.setState(() => ({ fieldValue: previousValue }));
      });
    this.setState(() => ({ isEditing: false }));
  }

  render() {
    const { consultantHealthInsurer } = this.props;
    const labelToUse =
      consultantHealthInsurer.healthInsurer.canHaveOverrideLabel && this.state.fieldValue
        ? this.state.fieldValue
        : consultantHealthInsurer.healthInsurer.name;
    return (
      <Cell
        title={consultantHealthInsurer.healthInsurer.canHaveOverrideLabel ? `Edit label for ${labelToUse}` : ''}
        onClick={this.startEditing}
        className={`sticky-table-cell batch-invoice-ccsd-code-insurer-column border-right ${consultantHealthInsurer.healthInsurer.canHaveOverrideLabel && 'isOther'}`}>
        {this.state.isEditing && consultantHealthInsurer.healthInsurer.canHaveOverrideLabel ? (
          <div className="input-group input-group--ccsdCode-inline-edit">
            <input
              autoFocus
              type="text"
              title="'Other' consultant specific label"
              value={this.state.fieldValue}
              onChange={this.handleChange}
              className="form-control"
            />
            <div className="input-group-append">
              <Button variant="primary" size="sm" title="Save Label Change" className="mb-0" onClick={this.saveAndStopEditing}>
                <i className="fas fa-check" />
              </Button>
              <Button variant="danger" size="sm" title="Cancel Label Change" className="mb-0" onClick={this.stopEditing}>
                <i className="fas fa-times" />
              </Button>
            </div>
          </div>
        ) : (
          labelToUse
        )}
      </Cell>
    );
  }
}

EditableConsultantHealthInsurerLabelCell.propTypes = {
  consultantHealthInsurer: PropTypes.object.isRequired,
  consultantHealthInsurerSingleUpdate: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(EditableConsultantHealthInsurerLabelCell);
